import { InputText } from 'primereact/inputtext';
import { ScrutinyTab } from '../ScrutinyTab';
import { Button } from 'primereact/button';
import { useEffect, useRef, useState } from 'react';
import { LetterShowClick } from '../../../config/Validate';
import { Toast } from 'primereact/toast';
import { TabPanel, TabView } from 'primereact/tabview';
import { getAllDetails } from '../../../service/ProductService';
import { CHECKDUPLICATE, SCRUTINYLIST } from '../../../config/ApiConstant';
import { freshApplicationName, SCHECK, SHOLD, SkeletonbodyTemplate, Skeletonitems, SPREPARE, SVERIFICATION } from '../../../appconfig/Settings';
import { setScrutinyActiveTab } from '../../../appconfig/AppHelper';
import { useNavigate, useParams } from 'react-router-dom';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { combinedFullNameTemplate, commonNameTemplate, dateTemplate } from '../../../appconfig/DatatableTemplateSetting';
import { ScrutinyListColumns } from '../../../appconfig/DatatableSetting';
import { Badge } from 'primereact/badge';
import { Dialog } from 'primereact/dialog';

export const FreshRegistrationScrutiny = () => {
    document.title = 'Fresh Registration Scrutiny | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //scrutinyRemainingList
    const [scrutinyRemainingList, setScrutinyRemainingList] = useState<any>([]);
    const [scrutinyRemaining, setScrutinyRemaining] = useState<any>(true);

    //duplicateata
    const [duplicateData, setDuplicateData] = useState<any>([]);
    const [duplicateModal, setDuplicateModal] = useState<any>(false);

    //tabIndex
    const [activeIndex, setActiveIndex] = useState<any>(0);

    //fileNO
    const [fileNo, setFileNo] = useState<any>(null);

    // errors
    const [errors, setErrors] = useState<any>({});

    //role
    const [roleName, setRoleName] = useState<any>(null);

    //loaders
    const [pageLoad, setPageLoad] = useState<boolean>(true);
    const [showLoading, setShowLoading] = useState<boolean>(false);

    const { status }: any = useParams();

    //navigate
    const naviagte = useNavigate();

    useEffect(() => {
        // Get Token from LocalStorage
        let token: any = localStorage.getItem('token');
        let role: any = localStorage.getItem('role');

        //Token Decode
        if (!window.cn(token)) {
            const { myUserObject } = JSON.parse(window.atob(token.split('.')[1]));
            if (!window.cn(role)) {
                let roleNm = role;
                let selectedTab = activeIndex === 0 ? setScrutinyActiveTab(roleNm) : atob(status);
                setActiveIndex(Number(selectedTab));
                setRoleName(roleNm);
            }
        }
    }, [status]);

    useEffect(() => {
        if (!window.cn(roleName) && !window.cn(activeIndex)) {
            getRemainingScrutinyList();
        }
    }, [roleName, activeIndex]);

    // Get Remaining Scrutiny List
    const getRemainingScrutinyList = async () => {
        try {
            setPageLoad(false);
            // List Fetch for Scrutiny Manager
            if (activeIndex === 0) {
                const response = await getAllDetails(SCRUTINYLIST + '?AppNm=' + freshApplicationName + '&applicationStatusType=' + SVERIFICATION);
                if (response) {
                    setScrutinyRemainingList(response);
                    setPageLoad(true);
                }
            }

            // List Fetch for Sub-Registrar
            if (activeIndex === 1) {
                const response = await getAllDetails(SCRUTINYLIST + '?AppNm=' + freshApplicationName + '&applicationStatusType=' + SPREPARE);
                if (response) {
                    setScrutinyRemainingList(response);
                    setPageLoad(true);
                }
            }

            // List Fetch for Registrar
            if (activeIndex === 2) {
                const response = await getAllDetails(SCRUTINYLIST + '?AppNm=' + freshApplicationName + '&applicationStatusType=' + SCHECK);
                if (response) {
                    setScrutinyRemainingList(response);
                    setPageLoad(true);
                }
            }

            // List Fetch for Registrar Hold Applications
            if (roleName === 'Registar' && activeIndex === 3) {
                const response = await getAllDetails(SCRUTINYLIST + '?AppNm=' + freshApplicationName + '&applicationStatusType=' + SHOLD);
                if (response) {
                    setScrutinyRemainingList(response);
                    setPageLoad(true);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setPageLoad(true);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    const searchScrutiny = async (fileNo: any) => {
        try {
            const { errors, isError } = LetterShowClick(fileNo);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setShowLoading(true);
                setScrutinyRemaining(false);

                naviagte(`/app/scrutiny/fresh-registration-scrutiny/${window.btoa(activeIndex)}/${window.btoa(fileNo)}`);

                //find duplicate
                checkDuplicate(fileNo);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setShowLoading(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could Not Load Data' });
            }
        }
    };

    //find duplicate
    const checkDuplicate = async (fileNo: any) => {
        try {
            if (!window.cn(fileNo)) {
                // this.setState({ fileNumber: fileNo });
                const response = await getAllDetails(CHECKDUPLICATE + '/' + fileNo);
                if (response) {
                    setDuplicateData(response);
                } else {
                    setDuplicateData([]);
                }
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDuplicateData([]);
            }
        }
    };
    //verificationStatus
    const verificationStatusTemplate = (rowData: any) => {
        return <div className="actions">{rowData?.verification_status === 1 ? <Badge value="True" severity="success"></Badge> : '-'}</div>;
    };

    //file No Template
    const fileNoTemplate = (rowData: any) => {
        return (
            <>
                <div className="avatar-div ">
                    <div className="emp-name link-name" onClick={() => searchScrutiny(rowData?.SrNo)} style={{ cursor: 'pointer' }}>
                        {rowData?.SrNo}
                    </div>
                </div>
            </>
        );
    };

    //action Template
    const actionTemplate = (rowData: any) => {
        return (
            <>
                <div className="actions">
                    <Button
                        label="Verification List"
                        style={{ width: 'max-content' }}
                        onClick={() => naviagte(`/app/scrutiny/verificationList/${window.btoa(rowData?.SrNo)}`)}
                        disabled={rowData?.verification_status == 0 ? true : false}
                        className="mr-2"
                    ></Button>
                    <Button label="Scrutiny" style={{ width: 'max-content' }} className="p-button p-button-success" onClick={() => searchScrutiny(rowData?.SrNo)}></Button>
                </div>
            </>
        );
    };

    // hidedupliactedialog
    const hideDuplicateDialog = () => {
        setDuplicateModal(false);
    };

    return (
        <>
            <ScrutinyTab mainTabLabel="Scrutiny (Gujarat)" />
            <Toast ref={toast} />

            <div className="grid crud-demo mt-4">
                <div className="col-12">
                    <div className="card">
                        <div className="p-fluid formgrid grid align-items-center">
                            <div className="field col-12 md:col-4">
                                <label htmlFor="regNo">
                                    File No <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText
                                    value={!window.cn(fileNo) ? fileNo : ''}
                                    name="fileNo"
                                    keyfilter="num"
                                    autoComplete="off"
                                    placeholder="Enter File No."
                                    onChange={(e) => setFileNo(e.target.value)}
                                    className={errors['fileNo'] && 'p-invalid'}
                                />
                                <small className="p-invalid-txt">{errors['fileNo']}</small>
                            </div>
                            <div className="field col-12 md:col-1 mt-4">
                                <Button label="Search" className="p-button-primary" onClick={() => searchScrutiny(fileNo)} loading={showLoading} />
                            </div>
                        </div>

                        <hr />

                        {scrutinyRemaining ? (
                            <>
                                {roleName == 'Register' ? (
                                    <>
                                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                            <TabPanel header="Scrutiny Verification"></TabPanel>
                                            <TabPanel header="Scrutiny Prepare"></TabPanel>
                                            <TabPanel header="Scrutiny Check"></TabPanel>
                                            <TabPanel header="Scrutiny Hold"></TabPanel>
                                        </TabView>
                                    </>
                                ) : (
                                    <>
                                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                                            <TabPanel header="Scrutiny Verification"></TabPanel>
                                            <TabPanel header="Scrutiny Prepare"></TabPanel>
                                            <TabPanel header="Scrutiny Check"></TabPanel>
                                        </TabView>
                                    </>
                                )}
                                {/* Datatable */}
                                {pageLoad ? (
                                    <>
                                        <DataTable
                                            value={scrutinyRemainingList}
                                            showGridlines
                                            stripedRows
                                            globalFilter={globalFilter}
                                            filters={globalFieldFilter}
                                            onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                            className="datatable-responsive p-datatable-sm"
                                            emptyMessage="No Data Found"
                                            removableSort
                                        >
                                            {ScrutinyListColumns.map((col: any, i: any) => {
                                                if (col.field === 'PayDt') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'remainder_date') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'BOD') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'verification_date') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={dateTemplate} style={{ minWidth: '8rem' }} />;
                                                } else if (col.field === 'name') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={combinedFullNameTemplate} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                                } else if (col.field === 'verification_status') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={verificationStatusTemplate} />;
                                                } else if (col.field === 'action') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={actionTemplate} />;
                                                } else if (col.field === 'ColName') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={commonNameTemplate} />;
                                                } else if (col.field === 'SrNo') {
                                                    return <Column key={col.field} field={col.field} header={col.header} body={fileNoTemplate} />;
                                                } else if (col.field === 'sr_no') {
                                                    return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;
                                                } else {
                                                    return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                                }
                                            })}
                                        </DataTable>
                                    </>
                                ) : (
                                    <>
                                        {/* Skeleton Data table */}
                                        <DataTable value={Skeletonitems}>
                                            {ScrutinyListColumns.map((col: any, i: any) => (
                                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                            ))}
                                        </DataTable>
                                    </>
                                )}
                            </>
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>

            {/* Duplicate Modal Start */}

            <Dialog visible={duplicateModal} style={{ width: '750px' }} header={'Duplicate Data'} modal onHide={hideDuplicateDialog}>
                <div className="p-2">
                    <DataTable value={duplicateData} emptyMessage="No Data Found">
                        <Column field="SrNo" header="SrNo"></Column>
                        <Column field="RegNo" header="Reg No"></Column>
                        <Column field="BOD" header="DOB" body={dateTemplate}></Column>
                        <Column field="name" header="Name" body={combinedFullNameTemplate}></Column>
                    </DataTable>
                </div>
            </Dialog>
            {/* Duplicate Modal End */}
        </>
    );
};
